import axios from "axios";
import { AuthToken } from "../features/auth/services/model/AuthToken";
import SessionTimeoutManager from "./SessionTimeoutManager";

export const AUTH_TOKEN_KEY = "auth_token";

interface AuthTokenHookInterface {
  expire_current_token?: boolean;
}

// This function remains a utility and does not use hooks, so it's fine as is.
const getTokenFromCookies = (): string | undefined => {
  const cookieString = document.cookie;
  const cookies = cookieString
    .split("; ")
    .reduce((acc: Record<string, string>, current) => {
      const [key, value] = current.split("=");
      acc[key] = value;
      return acc;
    }, {} as Record<string, string>);
  return cookies.firebase_id_token;
};

const storeTokenInCookies = (token: string, expiration: Date): void => {
  const now = new Date();
  const timeUntilExpiration = Math.floor(
    (expiration.getTime() - now.getTime()) / 1000
  );
  document.cookie = `firebase_id_token=${token}; max-age=${timeUntilExpiration}; path=/; domain=.jemhr.online; Secure; SameSite=None`;
};

const deleteAuthToken = (): void => {
  storeTokenInCookies("", new Date(Date.now() - 1000));
};

const fetchAuthToken = async (
  authDefaults: AuthTokenHookInterface
): Promise<string | undefined> =>
  new Promise<string | undefined>((resolve) => {
    if (!SessionTimeoutManager.hasActiveSession()) {
      resolve(undefined);
      return;
    }

    if (authDefaults?.expire_current_token) {
      deleteAuthToken();
    }
    const token = getTokenFromCookies();
    if (token) {
      resolve(token);
    } else {
      axios
        .get("/firebase-auth/custom_token/")
        .then((response) => {
          const authToken: AuthToken = response.data;
          storeTokenInCookies(
            authToken.token,
            new Date(authToken.expiration_time) // ISO 8601 string UTC converted to local time
          );
          resolve(authToken.token);
        })
        .catch(() => {
          resolve(undefined);
        });
    }
  });

export { deleteAuthToken };
export default fetchAuthToken;
